exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */.bpg-image-container{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:baseline;align-items:baseline;-ms-flex-pack:end;justify-content:flex-end;max-width:1170px;width:100%}[dir] .bpg-image-container{margin:0 auto 0}.bpg-image-container img{height:25px}@media (min-width:768px){.bpg-image-container img{height:32px}}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/bpg-image/bpg-image.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/bpg-image/bpg-image.component.scss
// module chunks = 0